import { render, staticRenderFns } from "./ExportDataAsCsv.vue?vue&type=template&id=51490e82&"
import script from "./ExportDataAsCsv.vue?vue&type=script&lang=js&"
export * from "./ExportDataAsCsv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports